import type { UiLocale } from '@/i18n/types'
import type { MinCopy } from '@/i18n/types'
import { minEn } from './en'
import { minRu } from './ru'
import { minUk } from './uk'
import { minPl } from './pl'
import { surfaceEn } from './surfaceEn'
import { surfaceRu } from './surfaceRu'
import { surfaceUk } from './surfaceUk'
import { surfacePl } from './surfacePl'

const CORE_BY_LOCALE = {
  en: minEn,
  ru: minRu,
  uk: minUk,
  pl: minPl,
} as const

const SURFACE_BY_LOCALE = {
  en: surfaceEn,
  ru: surfaceRu,
  uk: surfaceUk,
  pl: surfacePl,
} as const

function mergeLocale(locale: UiLocale): MinCopy {
  const core = CORE_BY_LOCALE[locale] ?? minEn
  const surface = SURFACE_BY_LOCALE[locale] ?? surfaceEn
  return {
    ...core,
    ...surface,
    nav: {
      ...core.nav,
      practice: surface.pages.practice,
    },
  }
}

const CACHE: Partial<Record<UiLocale, MinCopy>> = {}

/** Fallback: uk → ru → en; pl → en; ru → en (Phase 44). */
export function getMinCopy(locale: UiLocale): MinCopy {
  const resolved: UiLocale =
    locale === 'uk' && !CORE_BY_LOCALE.uk
      ? 'ru'
      : CORE_BY_LOCALE[locale]
        ? locale
        : 'en'
  if (!CACHE[resolved]) {
    CACHE[resolved] = mergeLocale(resolved)
  }
  return CACHE[resolved]!
}

export { minEn, minRu, minUk, minPl }
